import { fromJS } from 'immutable';

export default {
    setBrands: (state, brands) => {
        return state.mergeIn(['list'], fromJS(brands));
    },
    updateBrands: (state, brands) => {
        return state.mergeIn(['list'], fromJS(brands));
    },
    updateBrand: (state, brandId, brand) => {
        return state.mergeIn(['list', brandId.toString()], fromJS(brand));
    },
    setBrand: (state, brandId) => {
        return state.deleteIn(['list', brandId.toString()]);
    }
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Brands/core.js